export const MORE_FILTERS_PRESET_TYPE = 'MORE_FILTER_V9';
export const MORE_FILTERS_ORDER_PRESET_TYPE = 'MORE_FILTER_ORDER_V9';
